import React from "react";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  handlePhotoClicked(e) {
    this.props.photoClicked(this.props.albumId, e);
  },
  render() {
    let photoDir0 = this.props.albumPhoto[0].is_wide ? "photo-w" : "photo-h";
    let photoSrc0 = this.props.albumPhoto[0].safe_image;
    let photoDir1 = this.props.albumPhoto[1].is_wide ? "photo-w" : "photo-h";
    let photoSrc1 = this.props.albumPhoto[1].safe_image;
    let photoDir2 = this.props.albumPhoto[2].is_wide ? "photo-w" : "photo-h";
    let photoSrc2 = this.props.albumPhoto[2].safe_image;
    return (
      <section className="touch-box" style={{ width: "40%", flexShrink: "0" }}>
        <div className="album-highlight-item">
          <div className="album-highlight" data-cat="1">
            <a className="album-highlight-photo-0">
              <div
                onClick={() => this.handlePhotoClicked(0)}
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <img className={photoDir0} src={photoSrc0} />
              </div>
            </a>
            <a className="album-highlight-photo-1">
              <div
                onClick={() => this.handlePhotoClicked(1)}
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <img className={photoDir1} src={photoSrc1} />
              </div>
            </a>
            <a className="album-highlight-photo-2">
              <div
                onClick={() => this.handlePhotoClicked(2)}
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                }}
              >
                <img className={photoDir2} src={photoSrc2} />
              </div>
            </a>
          </div>
          <span className="album-info">
            <p style={{ margin: "0px 5px" }}>{this.props.albumTitle}</p>
          </span>
        </div>
      </section>
    );
  },
});
